<template>
    <div>

        <div class="product_mobile banner-bg">

            <div class="banner-container ">
                <div class="banner-title banner-center animate__zoomInDown">Moonee</div>

                <div class="banner-content banner-center animate__zoomIn">
                    应用出海服务厂商
                </div>
                <div class="banner-content banner-center animate__zoomIn">
                    开放务实&nbsp;&nbsp;/&nbsp;&nbsp;用户导向&nbsp;&nbsp;/&nbsp;&nbsp;全球化视野
                </div>

            </div>

        </div>

        <div class="companyIntroduction pathContainer">
            <div class="small-block-introduction bg-block"></div>
            <div class="big-block-introduction bg-block"></div>
            <div id="公司简介" class="head-label">
                <!-- <h2> -->
                公司简介
                <!-- </h2> -->
            </div>
            <div class="company-introduction content-card text1" style="padding-top: 0px;">
                香港墨逸成立于2022年9月，致力于应用出海、移动广告投放与变现，为全球用户提供优质产品和服务。 产品业务线覆盖港澳台、东南亚、欧美等多个地区。
            </div>
            <div class="company-introduction content-card text1">
                始终保持初心，用开放务实的心态面对用户，以较高的市场敏锐度和行业发展前瞻性，持续探索和创新，精细化打磨产品，旨在将更极致的产品和服务带给全球用户。
            </div>
        </div>


        <div class="advantageContainer" style="position: relative;margin-bottom:3em">
            <div class="big-block-advantage bg-block"></div>
            <div id="我们的优势" class="head-label">
                <h2>
                    <!-- 我们的优势 -->
                </h2>
            </div>
            <div class="advantage-container">
                <div class="advantage-parent">
                    <el-row :gutter="10">
                        <el-col v-for="(item, index) in advantages" :key="index" :xs="12" :sm="12" :md="6">
                            <!-- <div class="border"> -->
                            <div class="advantage-img-parent">
                                <img :src="item.img" class="advantage-img" />
                            </div>
                            <div class="advantage-title">{{ item.title }}</div>

                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>




    </div>
</template>

<script>

export default {
    data() {
        return {
            fixed: false,
            advantages: [
                { title: "丰富的海外产品经验", img: require('../assets/smallStep/官网_slices-1/ad1.png') },
                { title: "富有创造力的年轻化团队", img: require('../assets/smallStep/官网_slices-1/ad2.png') },
                { title: "丰富的渠道资源", img: require('../assets/smallStep/官网_slices-1/ad3.png') },
                { title: "注重用户体验和员工成长", img: require('../assets/smallStep/官网_slices-1/ad4.png') },
            ],
        }
    },
    mounted() {
        //监听鼠标滚动事件
        // window.addEventListener('scroll', this.ScrollHandleEvent, true);
    },
    beforeDestroy() {
        // window.removeEventListener('scroll', this.ScrollHandleEvent, true)
    },
    methods: {
        SelecthandleEvent(key) {
            this.fixed = true;
            switch (key) {
                case '1':
                    // this.$router.push({ name: "Index" });
                    window.location.hash = "#公司简介";
                    break;
                case '2':
                    window.location.hash = "#我们的优势";
                    break;
                case '3':
                    window.location.hash = "#公司产品";
                    break;
                case '4':
                    window.location.hash = "#福利待遇";
                    break;
                case '5':
                    window.location.hash = "#联系我们";
                    break;
            }
        },

        OnClickedLogo() {
            // 获取高度
            let banner = document.getElementsByClassName('banner-bg')[0]
            let header = document.getElementsByClassName('header')[0]
            let bannerOffSetTop = banner.offsetTop;
            let bannnerOffSetHeight = banner.offsetHeight
            let scrollTop = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset || 0;
            if (scrollTop < bannerOffSetTop + bannnerOffSetHeight) {
                this.fixed = false;
                if (!header.classList.contains("showTopMenu")) {
                    header.classList += ' showTopMenu'
                    header.classList.remove('hideTopMenu')
                }
            } else {
                if (header.classList.contains("showTopMenu")) {
                    header.classList.remove('showTopMenu')
                    header.classList += ' hideTopMenu'
                }
                this.fixed = true;
                // header.classList += ' hideTopMenu'
            }
        }
    }
}
</script>

<style lang="css" scoped>
@import '../assets/css/main.css';

/* bg-block */
.pathContainer {
    overflow: hidden;
}

.companyIntroduction {
    position: relative;
    overflow: hidden;
}

.bg-block {
    position: absolute;
    background-size: cover;
}


.small-block-introduction {
    background-image: url('../assets/smallStep/官网_slices/矩形8拷贝4.png');
    width: 64px;
    height: 64px;
    top: 20px;
    /* right: 10%; */
    left: 84%;
}

.big-block-introduction {
    background-image: url('../assets/smallStep/官网_slices/矩形8.png');
    /* width: 173px; */
    width: 328.5px;
    height: 328.5px;
    /* width: 657px;
    height: 657px; */
    left: 87%;
    /* right: -10%; */
    top: 73px;
}

.big-block-advantage {
    background-image: url('../assets/smallStep/官网_slices/矩形8拷贝.png');
    width: 328.5px;
    height: 328.5px;
    bottom: 20%;
    left: -8%;
}

.big-block-benefit {
    background-image: url('../assets/smallStep/官网_slices/矩形8拷贝3.png');
    width: 151px;
    height: 151px;
    top: 10%;
    left: -2%;
}

.small-block-benefit {
    background-image: url('../assets/smallStep/官网_slices/矩形8拷贝2.png');
    width: 80px;
    height: 80px;
    top: 5%;
    right: 10%;

}

.xs-block-benefit {
    background-image: url('../assets/smallStep/官网_slices/矩形8拷贝5.png');
    width: 226px;
    height: 226px;
    bottom: -35%;
    right: 0%;
}

/* bg-block */


.el-menu--horizontal>.el-menu-item.is-active {
    border-bottom: 2px solid #959ba0 !important;
}



.add-fixed {
    position: fixed;
    z-index: 9999;
    top: 0;
    margin: 0 auto !important;
}

.productContainer {
    /* width: 80%; */
    width: 62%;
    height: 550px;
    background-color: #F3F5F7;
    border-radius: 57px;
    /* margin-top: 10em;
    margin-left: auto;
    margin-right: auto; */
    margin: 10em auto 0 auto;
}


.iconListContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    /* background-color: #fff; */
}

.iconListImg {
    overflow: hidden;
    width: 10em;
    height: 10em;
    border-radius: 20%;
}

.product_mobile_content {
    width: 100%;
    margin-top: 15px;
}

.product_mobile {
    align-items: center;
    /* margin: 20px auto; */
}

.banner-bg {
    background-image: url('../assets/background/Background3.jpg');
    /* background-size: 100%; */
    background-size: cover;
    background-position: center;
    width: 100%;
    /* height: 800px; */
    /* height: 501px; */
    height: 663px;
    background-repeat: no-repeat;
    position: relative;
    color: #fff;
    /* background-attachment: fixed; */
}

.banner-bg .banner-container {
    width: 80%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    color: #fff;
}

.banner-text-center {
    text-align: left;
    color: #fff;
}

.banner-title {
    font-size: 5em;
    font-weight: bolder;
    margin-bottom: 1em;
}

.banner-center {
    text-align: center;
}

.banner-content {
    /* font-size: 24px; */
    font-size: 1.5rem;
    font-weight: bolder;
    /* width: 50%; */
    margin-top: 1em;
}

.head-label {
    /* margin: 2.5em 0; */
    /* margin-top: 2em; */
    font-size: 2.5em;
    text-align: center;
    padding-top: 67px;
    /* margin-top: 120px; */
    font-weight: bold;
    margin-bottom: 80px;
}

.small-menu-container {
    height: 65px;
    width: 100%;
    /* margin: 1em auto; */
}

.small-menu {
    margin: 0 auto;
    text-align: center;
    display: flex;
    justify-content: center;
    /* font-size: 1em; */
}

.small-menu .item-menu {
    color: #666;
    font-family: PingFangSC-Regular, PingFang SC;
    cursor: pointer;
}

.content-card {
    width: 62% !important;
    padding-top: 30px;
    margin: 0 auto;
}

.text1 {
    /* margin: 0; */
    font-size: 28px;
    line-height: 48px;
    /* font-size: 1.6em; */
    /* line-height: 2em; */
    font-family: PingFangSC-Regular, PingFang SC, "Gill Sans", sans-serif;
    font-weight: 400;
    color: #000;
}

.advantage-container {
    width:65%;
    margin: 0 auto;
}

.advantage-img-parent {
    text-align: center;
    width: 100%;
    height: 100%;
    /* display: flex;
    justify-content: space-around;
    align-items: center; */
}


.advantage-container .advantage-img {
    box-shadow: 0 0.75em 0.75em 0 rgb(0 0 0 / 20%);
    width: 11.65625em;
    height: 8.28125em;
    text-align: center;
    max-width: 100%;
    max-height: 100%;
    margin: auto auto;
    /* width: 357px; */
    /* width: 100%; */
    /* height: 265px; */
    /* height: 100%; */
}

.advantage-container .advantage-title {
    margin-top: 1.7em;
    margin-bottom: 1.7em;
    text-align: center;
    font-size: 1.125em;
    font-weight: bold;

}


.border_parent {
    width: 90%;
    margin: auto;
}

.border {
    border-radius: 6px;
    border: 1px solid #EBEEF5;
    height: auto;
    /* margin: 10px; */
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    padding-bottom: 25px;
}

.border_one {
    margin-left: 0;
}

.border_title {
    /*  */
    margin: 1em 0;
    margin-top: 2em;
    font-family: "PingFang SC";
    /* margin-top: 10px; */
    font-size: 1.5em;
    height: 3em;
    font-weight: 500;
    text-align: center;
    /* color: #404040; */
    /* color: #666; */
    color: rgba(0, 0, 0, 0.888);
}

.border_img_parent {
    margin-top: 20px;
    display: flex;
    justify-content: center;
}

.border_img {
    /* width: 106px;
    height: 126px; */
    width: 53px;
    height: 63px;
    margin-top: 42.25px;
    margin-left: auto;
    margin-right: auto;
}


.border_content_one {
    margin-top: 20px;
    font-size: 1em;
    color: #666;
    text-align: center;
    text-shadow: rgb(68, 68, 68);
}

.border_content_two {
    margin-top: 5px;
    font-size: 1.125em;
    margin-bottom: 25px;
    text-align: center;
}

.img_border {
    margin-top: 15px;
    width: 80px;
    height: 80px
}


.benefit-parent {
    width: 62%;
    margin: 112.25px auto;
}

.benefit-title {
    text-align: center;
    font-size: 1em;
    font-weight: bold;
    margin-top: 27px;
}

.benefit-border {
    background-color: #FFF7F3;
    box-shadow: 0 2px 16px 0 rgba(221, 127, 65, 0.27);
    border-radius: 30px;
    border: none;
}

.iconListGameName {
    font-size: 1.5em;
    width: 80%;
    margin: 1em 0;
    color: rgba(0, 0, 0, );
    font-weight: bold;
}

.text_bottom_shadow {
    position: relative;
}

.text_bottom_shadow::after {
    content: "";
    width: 98%;
    height: 0.23em;
    background: rgba(136, 136, 136, 0.233);
    position: absolute;
    border-radius: 25%;
    top: 86%;
    left: 50%;
    transform: translate(-50%, -50%);

}

.contactContainer {
    position: relative;
    width: 100%;
    height: auto;
    background-image: url('../assets/smallStep/官网_slices/组\ 307.png');
    background-size: 120% 120%;
    background-position: center;
    padding: 90px 0;
}


.contactContainer .innerContactContainer {
    width: 62%;
    margin: 55px auto;
    background-color: #fff;
    border-radius: 20px;
}

.hr {
    text-align: center;
    width: 2px;
    height: 110px;
    background-color: rgba(207, 207, 207, 1);
    margin: 0 auto;
}

.con-container {
    margin: 0 auto;
    width: 90%;
    align-items: flex-start;
    /* margin: 2em auto; */
    /* display: flex;
    justify-content: center; */

}

.con-title {
    font-size: 1.5em;
    color: #222;
    font-weight: 600;
    /* margin: 1em 0; */
    margin-bottom: 1em;
    /* text-align: center; */
    text-align: left;
}


.con-content {
    margin-bottom: 55px;
    /* text-align: center; */
    text-align: left;
    line-height: 2em;
}


.showTopMenu {
    opacity: 255;
    transition: opacity 1s ease-in-out;
}

.hideTopMenu {
    opacity: 0;
    transition: opacity 1s ease-in-out;
}

.el-carousel__item {
    opacity: 0;
    transition: opacity 0.25s ease-in-out;
}

.is-in-stage {
    opacity: 1;
    /* transition: opacity 0.5s ease-in-out; */
}

.footer {
    font-size: 0.1em;
    text-align: center;
    justify-content: space-between;
}

.footer span {
    width: 33%;
}
</style>
<style scoped>
/* 屏幕设备适配 max-device-width: 400px */
@media screen and (max-device-width: 415px) {
    .slider_img {
        height: 250px;
        width: 100%;
    }

    .banner-title {
        font-size: 2em;
    }

    .banner-content {
        font-size: 1em;
    }

    .head-label {
        margin: 0;
    }

    .head-label h2 {
        font-size: 1.2em;
        margin: 0.5em 0;
    }

    .company-introduction {
        font-size: 1em;
        line-height: 1.5em;
        padding-top: 15px;
    }


    .border_parent {
        display: flex;
        width: 90%;
        margin: auto;
        height: auto;
        flex-direction: column;
    }

    .border {
        border-radius: 6px;
        border: 1px solid #EBEEF5;
        float: left;
        width: 90%;
        height: auto;
        margin: 10px 0 auto;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
            /*background: aquamarine;*/
    }

    .border_img_parent {
        margin-top: 0;

    }

    .border_title {
        font-family: "PingFang SC";
        margin-top: 15px;
        font-size: 1em;
        font-weight: 600;
        padding-bottom: 1em;
        height: 2em;
        width: 90%;
        margin: 0.5em auto;
    }

    .border_content_one {
        margin-top: 5px;
        font-size: 0.8em;
        height: 2em;
        line-height: 2em;
    }

    .text_bottom_shadow::after {
        display: none;
    }

    .border_content_two {
        margin-top: 5px;
        font-size: 1.125em;
        margin-bottom: 8px;
    }

    .img_border {
        margin-top: 8px;
        width: 80px;
        height: 80px
    }

    .iconListImg {
        width: 120px;
        height: 120px;
    }

    .iconListGameName {
        font-size: 0.85em;
        width: 80%;
    }



    .product_mobile {
        /* width: 90%; */
        align-items: center;
        /* margin: 20px auto; */
        height: auto;
        /* background: #F2F6FC; */
    }

    .product_mobile_content {
        width: 100%;
        margin-top: 15px;
    }

    .banner-bg {
        height: 250px;
        width: 100%;
        /* margin: 0 auto; */
        background-size: cover;
        background-position: 50%;
    }

    .con-container {
        margin: 1em auto;
    }

    .con-title {
        font-size: 1.25em;
    }

    .con-content {
        margin-bottom: 2.5em;
    }

    .footer {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 10px auto;
        width: 90%;
        color: #222;
        font-size: 0.88em;
        opacity: 0.6;
    }

    .footer span {
        /* width: 30%; */
        text-align: center;
    }

    .footer span a {
        display: inline-block;
    }


}
</style>